import React from 'react'
import {Button, Modal} from 'semantic-ui-react'

export const CancelTrainingModal = ({open, onSuccess, onCancel}) => {
    return (
        <Modal
            open={open}
            onClose={() => console.log("CLOSE")}
            basic
            size='small'
            closeOnEscape={false}
            closeOnDimmerClick={false}
        >
            <Modal.Header icon='users' content='Sikker på at treningen skal avlyses?'/>
            <Modal.Actions>
                <Button inverted onClick={onCancel} color='red' content='Nei'/>
                <Button inverted onClick={onSuccess} color='green' content='Ja'/>
            </Modal.Actions>
        </Modal>)
}



// WEBPACK FOOTER //
// ./src/Components/CancelTraningModal.js